import { toFormData } from 'core/util/objects';

import FileImportType from 'core/ovations-api/enums/FileImportType';
import { Deserializer, makeQueryStringSerializer } from 'core/lib/serializer';
import apiFetch from './apiFetch';
import { API_URL } from './constants';
import * as Types from './definitions';

interface FileImportResponse {
    totalRecords: number;
    items: FileImport[];
}

export const defaultRequest: Types.FileImportSearchRequest = {
    page: 1,
};

const serializer = makeQueryStringSerializer<Types.FileImportSearchRequest>(defaultRequest, {
    page: Deserializer.Int,
});
export default class FileImport {
    static defaultRequest = defaultRequest;

    static deserializeRequest = serializer.deserialize;

    static serializeRequest = serializer.serialize;

    static async fetchAll(
        clientId: string,
        programId: string,
        fileImportType: FileImportType,
    ): Promise<FileImportResponse> {
        const url = `${API_URL}/api/v1/client/${clientId}/program/${programId}/FileImport/${fileImportType}`;
        const response = await apiFetch(url);
        const json = await response.json();
        return json;
    }

    static async search(
        clientId: string,
        programId: string,
        fileImportType: FileImportType,
        fileImportSearchRequest: Types.FileImportSearchRequest,
    ): Promise<Types.SearchResultsResponse<Types.FileImport>> {
        const query = FileImport.serializeRequest(fileImportSearchRequest, true);
        const url = `${API_URL}/api/v1/client/${clientId}/program/${programId}/FileImport/${fileImportType}?${query}`;

        const response = await apiFetch(url);
        const files: Types.SearchResultsResponse<Types.FileImport> = await response.json();
        return files;
    }

    static async fetchFile(clientId: string, programId: string, url: string): Promise<unknown> {
        const response = await apiFetch(
            `${API_URL}/api/v1/client/${clientId}/program/${programId}/FileImport/File?fileName=${url}`,
        );
        const text = await response.text();
        return text;
    }

    static async create(
        clientId: string,
        documentToSave: Types.FileImport,
        fileImportType: FileImportType,
    ): Promise<Types.FileImport> {
        const response = await apiFetch(
            `${API_URL}/api/v1/client/${clientId}/program/${documentToSave.programId}/FileImport/${fileImportType}`,
            {
                method: 'POST',
                body: toFormData(documentToSave),
            },
        );
        const newDocument: Types.FileImport = await response.json();
        return newDocument;
    }
}
